import { Outlet, useLocation } from "react-router-dom";

import { useStoreUrlParams } from "@/features/onboarding/hooks";
import { useEverflowClick } from "@/features/onboarding/hooks/use-everflow-click";
import { useLanguageFromParams } from "@/shared/hooks";
import { useMouseflowSession } from "@/shared/lib/mouseflow/hooks/use-mouseflow-session";
import { Layout } from "@/shared/ui";
import { QUESTIONNAIRE_STEPS } from "../router/constants";

export const QuestionnaireLayout = () => {
  useLanguageFromParams();
  useEverflowClick();
  useStoreUrlParams();
  useMouseflowSession();

  const { pathname } = useLocation();

  const currentStepIndex = QUESTIONNAIRE_STEPS.findIndex((step) =>
    pathname.startsWith(step),
  );

  const progress = ((currentStepIndex + 1) / QUESTIONNAIRE_STEPS.length) * 100;

  return (
    <div className="flex h-dvh flex-col bg-white">
      <Layout.Header progress={progress} />
      <Outlet />
    </div>
  );
};
